import React from 'react';
import { CAMPAIGN_STATUS, withCampaigns } from '@domain/campaigns';
import { EmptyBudgetField } from '@shared/components/tables/column-components/empty-budget-field/empty-budget-field.styles';
import { EditCurrencyField } from '@shared/components/tables/column-components/edit-currency-field/edit-currency-field';
import { Cell } from '@shared/components/tables/column-components/table.types';
import { CampaignRow } from '../../campaign-table.types';

interface CampaignBudgetFieldImplProps {
    cell: Cell<CampaignRow>
    editCampaignReportsStats: Function
}

const CampaignBudgetFieldImpl = ({
    cell,
    editCampaignReportsStats,
}: CampaignBudgetFieldImplProps) => {
    const { row } = cell;
    const { original } = row;
    const {
        account_id: accountId,
        platform,
        budget,
        name,
        status,
        campaign_id: campaignId,
        sublevel_id: subLevelId,
        budget_id: budgetId,
        main_budget: mainBudget,
    } = original;

    const onChangeBudget = (newBudgetValue) => {
        if (newBudgetValue !== parseFloat(String(budget))) {
            editCampaignReportsStats({
                accountId,
                platform,
                campaignId,
                subLevelId,
                field: 'budget',
                fieldValue: newBudgetValue,
                originalValue: budget,
                budgetId,
            });
        }
        return true;
    };

    const isDisabled = status !== CAMPAIGN_STATUS.ENABLED || !budget;

    const isEmptyBudgetField = status === CAMPAIGN_STATUS.ENDED
        || status === CAMPAIGN_STATUS.REMOVED;

    return (
        isEmptyBudgetField
            ? (
                <EmptyBudgetField>
                    --
                </EmptyBudgetField>
            )
            : (
                <EditCurrencyField
                    defaultValue={mainBudget || budget}
                    key={name}
                    currency=""
                    onChange={onChangeBudget}
                    disabled={isDisabled}
                />
            )
    );
};

export const CampaignBudgetField = withCampaigns(CampaignBudgetFieldImpl);
